import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';
import { AppTextService } from '@fi-shared/app-text';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { OnInit, Directive } from '@angular/core';
import { IChecklistReportModel } from '../checklist-report';
import { ChecklistReportHelperService } from '../checklist-report-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ChartOptions } from 'chart.js';
import { IChartClickEvent } from '@fi-shared/fi-chart/fi-chart';

@Directive()
export class ChecklistReportLastActivePeriodStatusBase extends ItemsListRowItemBase implements OnInit {
    totalCheckpoints: number;
    completedNumberOfUnits: any;
    totalNumberOfUnits: any;
    completedPercentage: any;

    chartData: number[];
    chartColors: string[];
    chartLabels: string[];
    chartOptions: ChartOptions<'doughnut'>;

    private report: IChecklistReportModel;
    private detectDevices: DetectDevicesService;
    private checklistReportHelperService: ChecklistReportHelperService;

    ngOnInit(): void {
        super.ngOnInit();
        this.init(this.data);
    }

    private init(report: IChecklistReportModel) {
        const appText = this.injector.get(AppTextService);
        this.detectDevices = this.injector.get(DetectDevicesService);
        this.checklistReportHelperService = this.injector.get(ChecklistReportHelperService);

        this.report = this.data;
        this.chartData = report.LastActivePeriodStatus.Data;
        this.chartLabels = [];
        const colors = [];
        const statusData = {};

        report.LastActivePeriodStatus.Labels.forEach((label, index) => {
            this.chartLabels.push(appText.get(ChecklistModel.StatusTextIds[label]));
            colors.push(ChecklistModel.StatusColors[label]);
            statusData[label] = report.LastActivePeriodStatus.Data[index];
        });
        this.chartColors = colors;

        this.totalCheckpoints = this.chartData.reduce((a, b) => {
            return a + b;
        }, 0);

        this.completedNumberOfUnits =
            (statusData[ChecklistModel.Status.Ok] || 0) + (statusData[ChecklistModel.Status.Deviation] || 0);
        this.totalNumberOfUnits = report.LastActivePeriodStatus.Data.reduce((p1, p2) => {
            return p1 + p2;
        }, 0);
        this.completedPercentage = (this.completedNumberOfUnits / this.totalNumberOfUnits) * 100;
        this.completedPercentage = this.completedPercentage.toFixed(0);

        this.chartOptions = {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: (label) => {
                            const value = label.dataset.data[label.dataIndex] as number;
                            return ((value / this.totalCheckpoints) * 100).toFixed(2) + '%';
                        },
                    },
                },
                legend: {
                    display: false,
                },
            },
            cutout: '75%',
            animation: this.getAnimationConfig(),
            responsive: true,
            maintainAspectRatio: false,
        };
    }

    chartClick($event: IChartClickEvent) {
        this.checklistReportHelperService.onChartClick($event, (index) => {
            this.stateService.go(FiStateNames.Checklist.Report.View, {
                Id: this.report.Id,
                status: this.report.LastActivePeriodStatus.Labels[index],
            });
        });
    }

    private getAnimationConfig() {
        if (this.detectDevices.isMobilePhone()) return false;

        return {
            duration: 1500,
            //easing: 'easeOutBounce'
        };
    }
}
